import styled from 'styled-components'
import { media } from 'utils/media'

export const ShowForDesktop = styled.div`
  display: none;
  ${media.phoneUp} {
    display: block;
  }
`

export const ShowForMobile = styled.div`
  display: none;
  ${media.phoneDown} {
    display: block;
  }
`

export const ShowForTabletDown = styled.div`
  display: none;
  ${media.tabletDown} {
    display: block;
  }
`
